/* eslint-disable max-len */
import React from 'react';
import CircleClip from './CircleClip';

const PlayIcon = () => (
  <svg
    width="40"
    height="40"
    viewBox="0 0 40 40"
    className="spl-icon"
  >
    <CircleClip rotate={true} start="495 18 18" stop="315 18 18" />
    <g fill="#fff">
      <path
        d="M13.39 11.309c-.08.027-.209.073-.287.101-.172.062-.907.776-1.008.98-.187.375-.189.429-.174 5.677.017 5.996-.05 5.365.64 6.059.545.55.71.622 1.415.622.666 0 .854-.08 1.36-.581.744-.735.708-.398.69-6.61l-.015-4.731-.138-.299c-.43-.931-1.618-1.514-2.482-1.218m7.995.043c-.265.082-.356.147-.74.527-.72.712-.68.36-.68 6.042.002 5.827-.033 5.515.709 6.255.973.97 2.454.721 3.222-.543.187-.307.197-.636.183-5.857l-.013-5.047-.108-.225c-.096-.2-.574-.729-.892-.986-.312-.253-1.138-.335-1.68-.166"/>
      <path
        d="M14.563 11.329c.422.106 1.086.713 1.31 1.198l.138.299.015 4.731c.018 6.212.054 5.875-.69 6.61-.506.5-.694.58-1.36.58-.704 0-.87-.072-1.416-.621-.689-.694-.622-.063-.64-6.06-.014-5.247-.012-5.3.175-5.677.101-.203.836-.917 1.008-.979.372-.134.457-.151.787-.156.195-.003.498.03.673.075m8.073.007c.173.048.367.13.431.182.318.257.796.786.892.986l.108.225.013 5.047c.014 5.22.004 5.55-.183 5.857-.768 1.264-2.25 1.513-3.222.543-.742-.74-.707-.428-.708-6.255-.001-5.681-.04-5.33.679-6.042.616-.61 1.187-.766 1.99-.543"/>
    </g>
  </svg>

);

PlayIcon.propTypes = {};

export default PlayIcon;